/**
 * @param {import('@/types/api').Product[]} products
 * @param {string} barcode
 */
export function findProductByBarcode(products, barcode) {
  const normalized = String(barcode ?? '').trim()
  if (!normalized) return null

  return products.find((product) => {
    const productBarcode = String(product.barcode ?? '').trim()
    const sku = String(product.sku ?? '').trim()
    return productBarcode === normalized || sku === normalized
  }) ?? null
}

/**
 * @param {KeyboardEvent} event
 */
export function shouldIgnoreBarcodeKeyEvent(event) {
  const target = event.target
  if (!target || typeof target !== 'object') return false

  const tag = target.tagName
  if (tag === 'INPUT' || tag === 'TEXTAREA' || tag === 'SELECT') return true
  if (target.isContentEditable) return true

  if (typeof target.closest === 'function' && target.closest('[data-barcode-scan-ignore="true"]')) {
    return true
  }

  return false
}

/**
 * @param {string} buffer
 * @param {string} key
 * @param {number} now
 * @param {number} lastKeyTime
 * @param {number} [gapMs=80]
 */
export function appendBarcodeScanChar(buffer, key, now, lastKeyTime, gapMs = 80) {
  if (key.length !== 1) {
    return { buffer, lastKeyTime }
  }

  const nextBuffer = now - lastKeyTime > gapMs ? '' : buffer

  return {
    buffer: `${nextBuffer}${key}`,
    lastKeyTime: now,
  }
}
